import {UiFieldBaseSchema} from "./UiField";
import {z} from "zod";

export const CheckboxFieldSchema = UiFieldBaseSchema.extend({
    componentType: z.literal('CheckboxField'),
});

export type CheckboxField = z.infer<typeof CheckboxFieldSchema>;